import React from "react";
import { Link } from "react-router-dom";
import { Text, Image } from "./elements";

interface ILogoProps {
  src: string;
  alt: string;
  name?: string;
  href: string;
  className?: string;
}

export function Logo({ src, alt, name, href, className }: ILogoProps) {
  return (
    <>
      {name ? (
        <Link to={href} className={`mc-logo-group ${className}`}>
          <Image src={src} alt={alt} style={{ with: 250, height: 50 }} />
          <Text as="span">{name}</Text>
        </Link>
      ) : (
        <Link to={href} className={`mc-logo ${className}`}>
          <Image src={src} alt={alt} />
        </Link>
      )}
    </>
  );
}
